import React from 'react';
/**
 * NotFoundPage Component
 *
 * A user-friendly 404 error page that provides navigation options
 * and helpful links when users encounter non-existent routes.
 */
export const NotFoundPage: React.FC = () => {
  return (
    <div
      className='min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4 sm:px-6 lg:px-8'
      data-pte-name='not-found-page'
    >
      <div className='max-w-md w-full space-y-8 text-center'>
        {/* 404 Illustration */}
        <div className='mb-8' data-pte-name='not-found-page-illustration'>
          <div className='text-9xl font-bold text-indigo-600 mb-4'>404</div>
          <div className='w-24 h-1 bg-indigo-600 mx-auto rounded-full'></div>
        </div>

        {/* Error Message */}
        <div className='space-y-4' data-pte-name='not-found-page-message'>
          <h1 className='text-3xl font-bold text-gray-900'>Page Not Found</h1>
          <p className='text-lg text-gray-600 leading-relaxed'>
            Oops! The page you're looking for doesn't exist. It might have been
            moved, deleted, or you entered the wrong URL.
          </p>
        </div>
      </div>
    </div>
  );
};
